import { useContext } from 'react';
import SimpleAppStateProvider from '@/contexts/simple-app-state';

const useSimpleAppState = () => {
  const value = useContext(SimpleAppStateProvider);

  return value;
};
    
export default useSimpleAppState;